/**
 * Created by eliranm on 10/11/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var template = require('content-templates/content-import-errors/contentImportErrorsTableView.tmpl');
    var ContentImportErrorsTableRowView = require('content-views/content-import-errors/ContentImportErrorsTableRowView');

    var ContentImportErrorsTableView = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsTableView = Marionette.GridView.extend({
            template: template,
            itemView: ContentImportErrorsTableRowView,
            itemViewContainer: 'tbody',
            selectedItem: null,
            className: 'table-main ui-table',

            ui:{
                lobs: '.lobs'
            },

            onRender: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this.ui.lobs.removeClass("hide");
                }
            }
        });
    });

    return ContentImportErrorsTableView;
});
